import { useState, useCallback } from 'react';
import { pwm202Api, FM120 } from '../../../services/pwm202Api';

export function usePWM202Navigation() {
  const [list, setList] = useState<FM120[]>([]);
  const [currentIdx, setCurrentIdx] = useState(-1);

  const fetchList = useCallback(async () => {
    try {
      const res = await pwm202Api.list(1, 200);
      setList(res.data ?? []);
    } catch {
      setList([]);
    }
  }, []);

  const setCurrentById = useCallback((id: string) => {
    const idx = list.findIndex(r => r.fm120_01 === id);
    if (idx >= 0) setCurrentIdx(idx);
  }, [list]);

  const goFirst = useCallback((): string | null => {
    if (list.length === 0) return null;
    setCurrentIdx(0);
    return list[0].fm120_01;
  }, [list]);

  const goLast = useCallback((): string | null => {
    if (list.length === 0) return null;
    const idx = list.length - 1;
    setCurrentIdx(idx);
    return list[idx].fm120_01;
  }, [list]);

  const goPrev = useCallback((): string | null => {
    if (currentIdx <= 0) return null;
    const next = currentIdx - 1;
    setCurrentIdx(next);
    return list[next].fm120_01;
  }, [currentIdx, list]);

  const goNext = useCallback((): string | null => {
    if (currentIdx >= list.length - 1) return null;
    const next = currentIdx + 1;
    setCurrentIdx(next);
    return list[next].fm120_01;
  }, [currentIdx, list]);

  const hasPrev = currentIdx > 0;
  const hasNext = currentIdx < list.length - 1 && list.length > 0;

  return { list, currentIdx, fetchList, setCurrentById, goFirst, goLast, goPrev, goNext, hasPrev, hasNext };
}
